/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_GoogleInputs */

const en_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const de_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const fr_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const es_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const it_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const nl_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const pl_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const fi_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const da_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const sv_auth_google = /** @type {(inputs: Auth_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

/**
* | output |
* | --- |
* | "Google" |
*
* @param {Auth_GoogleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_google = /** @type {((inputs?: Auth_GoogleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_GoogleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_google(inputs)
	if (locale === "fr") return fr_auth_google(inputs)
	if (locale === "es") return es_auth_google(inputs)
	if (locale === "it") return it_auth_google(inputs)
	if (locale === "nl") return nl_auth_google(inputs)
	if (locale === "pl") return pl_auth_google(inputs)
	if (locale === "fi") return fi_auth_google(inputs)
	if (locale === "da") return da_auth_google(inputs)
	if (locale === "sv") return sv_auth_google(inputs)
	return en_auth_google(inputs)
});